import React from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {DomoLogoColor48} from 'images/ImageConstants';
import {offsetViewport} from 'state/viewport/viewportActions';

import {analyticsTrack} from 'utilities/analytics';

import styles from './EmbedBanner.css?module';

class EmbedBanner extends React.Component {
  ref = React.createRef(null);
  componentDidMount() {
    const boundingBox = this.ref.current.getBoundingClientRect();
    this.props.offsetViewport({
      bottom: boundingBox.height,
    });
  }

  handleDomoClick = () => {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.PUBLIC__CARD__DOMO__CLICK, {
      card_id: this.props.cardId,
    });
  };

  // react/jsx-no-target-blank can be disabled because we are sending the user to domo.com.
  /* eslint-disable react/jsx-no-target-blank */
  render() {
    return (
      <div className={styles.container} ref={this.ref}>
        <a
          className={styles.logoLink}
          href="https://www.domo.com/?aid=embed092517&cta=pbd"
          target="_blank"
          rel="noopener"
          onClick={this.handleDomoClick}
        >
          <div className={styles.logoCaptionText}>
            <FormattedMessage
              id="EmbedBanner__PoweredBy"
              description="Branding to indicate the chart is powered by Domo"
              defaultMessage="powered by"
            />
          </div>
          <img className={styles.logoImage} src={DomoLogoColor48} alt="Domo" />
        </a>
      </div>
    );
  }
  /* eslint-enable react/jsx-no-target-blank */
}

export default connect(null, {
  offsetViewport,
})(EmbedBanner);
